<button #primary id="primary" mat-flat-button color="primary" hidden></button>
<button #accent id="accent" mat-flat-button color="accent" hidden></button>
<button #warn id="warn" mat-flat-button color="warn" hidden></button>
<router-outlet></router-outlet>